import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught an error:', error, info.componentStack);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary-ui">
          <div className="error-card">
            <div className="error-icon">⚠</div>
            <h2>Something went wrong</h2>
            <p>An unexpected error occurred while rendering this page.</p>
            {process.env.NODE_ENV === 'development' && (
              <pre className="error-detail">
                {this.state.error?.message}
              </pre>
            )}
            <button onClick={this.handleReset} className="error-retry-btn">
              Try Again
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
